import { BaseModel } from "@/models/base/BaseModel";

export class NewAdditionalService extends BaseModel {
  name: string;
  isInternal: boolean;
  canHavePremiumServicesEvents: boolean;
  providerName: string;
  category: string;
  categoryId: string;
  description: string;
  imageUrl: string;
  thumbnailUrl: string;
  serviceType: string;
  type: string;
  oneOffCost: number | string;
  subscriptionCost: number | string;
  noticePeriod: number | string;
  period: string;
  bookByResident: boolean;
  bookByFamily: boolean;
  isAddedToKiosk: boolean;
  byAppointment?: boolean;
  isTopMyhubList: false;
  availableHours: any;
  maxSlots: number;
  slotDurationInMins: string;
  participantLimit?: string;
  participantLimitNumber?: number;
  isWaitingList?: boolean;
  isOneToOne?: boolean;
  visitorName?: string;
  sendVendorEmailUponRequestAutomatically?: boolean;
  sendVendorEmailOptions?: any;
  orderIndex?: number;
  durationHours?: number;
  start?: Date;
  end?: Date;
  additionalPhotos?: Array<any>;
  location?: string;
  wing?: string;
  wingsIds: string[];
  waitingResidentsIds: string[];
  waitingResidents: any[];
  updatedLimitDateTime?: Date;
}